export const setGtmUserId = userId => {
  // https://developers.google.com/analytics/devguides/collection/ga4/user-id?sjid=2889741079116823107-AP&client_type=gtm
  try {
    if (window.dataLayer) window.dataLayer.push({ user_id: userId });
  } catch (e) {
    console.log(e);
  }
};
